'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@achra/ui/empty';
import { ServerCrash } from 'lucide-react';
import { useEffect } from 'react';
interface GenericErrorProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
function GenericError(t0) {
  const $ = _c(9);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] !== error.digest || $[1] !== error.message || $[2] !== error.stack) {
    t1 = () => {
      console.error("Error caught by boundary:", {
        message: error.message,
        digest: error.digest,
        ...(process.env.NODE_ENV === "development" && {
          stack: error.stack
        })
      });
    };
    $[0] = error.digest;
    $[1] = error.message;
    $[2] = error.stack;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== error) {
    t2 = [error];
    $[4] = error;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <EmptyHeader><EmptyMedia variant="icon"><ServerCrash /></EmptyMedia><EmptyTitle>Something went wrong</EmptyTitle><EmptyDescription>Something went wrong while loading this page. Please try again.</EmptyDescription></EmptyHeader>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== reset) {
    t4 = <main className="flex min-h-[calc(100dvh-13.875rem)] items-center justify-center px-6"><Empty className="bg-background mx-auto w-full max-w-sm border border-solid md:p-6">{t3}<EmptyContent><Button onClick={reset} variant="default">Try again</Button></EmptyContent></Empty></main>;
    $[7] = reset;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export { GenericError };